import api from '@/services/api'

export default {
  getAll(page, term, state, crm = false) {
    let params = '?page=' + page;

    if (term) {
      params += `&term=${term}`;
    }

    if (state) {
      params += `&state=${state}`;
    }

    if (crm) {
      params += `&crm=true`;
    }

    return api.get('/customers' + params)
  },

  getList(page, term) {
    return api.get(`/customers?page=${page}&term=${term}`)
  },

  exportCustomers(term) {
    return api({
      url: `/customers?term=${term}&export=true`,
      method: 'GET',
      responseType: 'blob',
    })
  },

  getSellerCustomers(page, term) {
    return api.get('/customers/seller?page=' + page + '&term=' + term)
  },

  createSellerCustomer(data) {
    return api.post('/customers/new', data)
  },

  exportSellerCustomers(term) {
    return api({
      url: `/customers/seller?term=${term}&export=true`,
      method: 'GET',
      responseType: 'blob',
    })
  },
}